import { fetch } from '@atlassian/eoc-fetch';

import { type RoutingRulesResponse } from '../../common/types';

export const getRoutingRules = (teamId: string) =>
	fetch<RoutingRulesResponse>(`/v1/teams/${teamId}/routing-rules`);
